export const clearDocsImages = {
  desktopAudit: {
    src: 'https://cdn.magicpatterns.com/uploads/m8gniGt458RfizBnfFEA8B/Section_2.png',
    alt: 'A strip of live desktop Clear Docs screens, from the document list to request and review modals, with two early mobile sketches below',
  },
  coreFlows: {
    src: 'https://cdn.magicpatterns.com/uploads/vyo5TD8fuP478Cg32JJXG7/Group_3.png',
    alt: 'Flow diagram: from the request and documents list, the user chooses to request, review or upload docs. Requesting goes through document type, description and recipient to send or save a draft; reviewing goes through filtering, the draft list and editing a description.',
  },
  beforeViewer: {
    src: 'https://cdn.magicpatterns.com/uploads/oomxKrJb92PPGgP52Gd61p/image_39.png',
    alt: 'Desktop review panel before: a Document Status dropdown, For Review and Inactive checkboxes, and Send to LOS as a separate button',
  },
  acceptMoves: {
    src: 'https://cdn.magicpatterns.com/uploads/da7g8AhTYpQoxF2WxGnB3a/Group_1.png',
    alt: 'Desktop document list with the Needs Review group highlighted and an arrow showing documents moving down into their categories',
  },
  acceptLands: {
    src: 'https://cdn.magicpatterns.com/uploads/72uXCvUeigy5R5hngAeQq6/Group_2.png',
    alt: 'Desktop document list with the APP category highlighted, its documents now showing the status Reviewed',
  },
  funnel: {
    src: 'https://cdn.magicpatterns.com/uploads/rMfu46ebpySuicNMNax1Kw/Button__Status_Funnel.png',
    alt: 'Flow diagram: a document opened for review branches by role to Ready to Ship, Approve or Accept buttons and their statuses; Reject from any role marks it inactive and unlinked',
  },
  buttonRules: {
    src: 'https://cdn.magicpatterns.com/uploads/4eqVr74BnYMJpmx4YEgiNT/ss.png',
    alt: 'Table of primary button rules: Accept for Loan Officer, Processor and Processor III; Approve for Processor III and Underwriter; Ready to Ship for Post Closing',
  },
  decisionsBoard: {
    src: 'https://cdn.magicpatterns.com/uploads/2X85TUae8zBx1ufBPYRQa3/Doc_Review_—_Decisions__Updates.png',
    alt: 'Document Review decisions board with sticky notes in five columns: Decided, Key findings, Proposals not final, Open questions, Actions and parked',
  },
};
